<template>

</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    
    export default {
        props: [],
    
        computed: {
            ...mapGetters([])
        },
        
        data() {
            return {
            
            }
        },
    }
</script>
